import { Action } from '../../../common/actions/core/action';

export class NoAuthBillInfoAddAction implements Action {
    constructor() { }
}


// WEBPACK FOOTER //
// src/app/no-auth/components/bill-info-add/bill-info-add.action.ts